import React from "react";
import {
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";

export const CollapsibleRow = ({
  childContracts = [],
  editsProof = [],
  component,
  renderList,
  renderProof = null,
  defaultOpen = true,
  childPadding = "0 0 0 24px",
  childBg = "#eee",
  childContractsTitle = "",
  editsProofTitle = ""
}) => {
  const [open, setOpen] = React.useState(defaultOpen);
  const toggleOpen = () => setOpen(!open);

  return (
    <>
      {childContracts?.length > 0 || editsProof.length > 0 ? (
        <>
          {React.cloneElement(component, { open, onCollapse: toggleOpen })}
          <TableRow style={{ background: childBg }}>
            <TableCell style={{ padding: childPadding }} colSpan={8}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <>
                  {editsProof.length > 0 && (
                    <Table size="small" style={{ tableLayout: "fixed" }}>
                      {editsProofTitle && (
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={5}>{editsProofTitle}</TableCell>
                          </TableRow>
                        </TableHead>
                      )}
                      <TableBody>{renderProof(editsProof)}</TableBody>
                    </Table>
                  )}
                  {childContracts.length > 0 && (
                    <Table size="small" style={{ tableLayout: "fixed" }}>
                      {childContractsTitle && (
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={5}>{childContractsTitle}</TableCell>
                          </TableRow>
                        </TableHead>
                      )}
                      <TableBody>{renderList(childContracts)}</TableBody>
                    </Table>
                  )}
                </>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      ) : (
        component
      )}
    </>
  );
};
